(() => {
  const menu = document.querySelector('.floating-shop-menu');
  const trigger = menu?.querySelector('.floating-shop-button');
  const backdrop = menu?.querySelector('.floating-shop-menu__backdrop');
  const accountMenu = document.querySelector('.mobile-menu');
  const accountTrigger = accountMenu?.querySelector(':scope > summary');

  const closeMenu = () => {
    if (!menu?.open) return;
    menu.removeAttribute('open');
    trigger?.focus();
  };
  const closeAccountMenu = () => {
    if (!accountMenu?.open) return;
    accountMenu.removeAttribute('open');
    accountTrigger?.focus();
  };

  backdrop?.addEventListener('click', closeMenu);
  document.addEventListener('click', (event) => {
    if (accountMenu?.open && !accountMenu.contains(event.target)) {
      accountMenu.removeAttribute('open');
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
      closeAccountMenu();
    }
  });
})();
